import { render, staticRenderFns } from "./FaultTypeGroupCreateOrUpdate.vue?vue&type=template&id=cc25d2a4&"
import script from "./FaultTypeGroupCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./FaultTypeGroupCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports